
<div class="TableLegend">
    <div class="legend-items">
        <div
            v-for="item in legendItems"
            :key="item.key"
            class="legend-item"
            :class="{ 'is-active': item.active }"
        >
            <div class="legend-indicator" :class="item.indicatorClass"></div>
            <span class="legend-text">{{ item.label }}</span>
        </div>
    </div>
</div>
